import { ref } from 'vue'
import { defineStore } from 'pinia'

const useMenuState = () => {
  const isOpen = ref(false)
  const open = () => {
    isOpen.value = true
  }
  const close = () => {
    isOpen.value = false
  }
  return {
    isOpen,
    open,
    close
  }
}

const useAttentionModalState = () => {
  const isOpen = ref(false)
  const titleKey = ref('')
  const descriptionKey = ref('')
  const buttonKey = ref('')

  const open = (keys: { titleKey: string; descriptionKey: string; buttonKey: string }) => {
    titleKey.value = keys.titleKey
    descriptionKey.value = keys.descriptionKey
    buttonKey.value = keys.buttonKey
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
    titleKey.value = ''
    descriptionKey.value = ''
    buttonKey.value = ''
  }

  return {
    isOpen,
    titleKey,
    descriptionKey,
    buttonKey,
    open,
    close
  }
}

export const useUiState = defineStore('uiState', () => {
  const seatIndex = ref<number | null>(null)
  const playerId = ref<string | null>(null)

  const modals = {
    createGame: useMenuState(),
    joinGame: useMenuState(),
    addBot: useMenuState(),
    editAvatar: useMenuState(),
    seatPlayerAlready: useMenuState(),
    attention: useAttentionModalState()
  }
  const panels = {
    editPlayer: useMenuState(),
    playersPanel: useMenuState(),
    sessionLog: useMenuState()
  }

  function closeAllPanels() {
    for (const prop in panels) {
      panels[prop as keyof typeof panels].close()
    }
  }

  return {
    modals,
    panels,

    closeAllPanels,

    seatIndex,
    playerId
  }
})
